import { Environment } from '@codebuild/cookie-jar/libs/environment';
import { Repository } from '@codebuild/cookie-jar/libs/repository';
import * as React from 'react';

export class UploaderMulti extends React.Component<any, {}> {

    public imageInputRef$: any;

    public attachmentServiceEndpoint: string = Environment.get('attachment');
    public state: any = {
        attachments: [],
        uploadQuantity: 0,
        loading: false,
        error: null
    };

    public componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (prevState.attachments !== this.state.attachments && this.state.attachments.length === this.state.uploadQuantity) {
            if (this.props.onUploadSuccess) {
                this.props.onUploadSuccess(this.state.attachments);
            }
        }
    }

    public render(): React.ReactNode {
        return <div className={'ProfileImageUploader'}>
            <label htmlFor={'MultiImageUploads'}>{this.props.trigger}</label>
            <input
                onChange={(e) => this.addFiles(e)}
                ref={(ref) => this.imageInputRef$ = ref}
                accept="image/*"
                className={'display-none'}
                type={'file'}
                id={'MultiImageUploads'}
                multiple={true}
            />
        </div>;
    }

    public async addFiles(e: any) {
        const files = e.target.files || [];
        this.setState({ loading: true, uploadQuantity: files.length });

        for (const file of files) {
            await this.addFile(file);
        }

        this.setState({ loading: false });
    }

    public async addFile(file: any) {
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);

        reader.onload = async () => {
            try {
                this.setState({ error: null });
                const upload = await this.createAttachment(Buffer.from((reader.result as Buffer)).toString('base64'));
                this.setState({ attachments: [...this.state.attachments, upload.default.payload || ''] });
            } catch (err) {
                this.setState({ error: err });
            }
        };
    }

    public async createAttachment(data: string) {
        try {
            const query = {
                data: data
            };

            return await Repository.post('/attachment', query, {}, {}, this.attachmentServiceEndpoint);
        } catch (e) {
            this.setState({ loading: false });
            return Promise.reject(e);
        }
    }
}
